export default {
  createSuccess: "Sales agent created successfully!",
  scopeAssigned: "Assignment saved",
  scopeRemoved: "Assignment removed",
  removeScopeError: "Could not remove assignment",
  create: {
    title: "Create sales agent",
    namePlaceholder: "Display name",
    emailPlaceholder: "agent@example.com",
    submit: "Create",
  },
  detail: {
    invalidRoute: "Invalid route.",
    roleLabel: "Sales agent",
    statAssociations: "Associated users",
    loadDetail: "Loading sales agent details...",
    loadError: "Failed to load sales agent",
    toastStatusUpdated: "Sales agent status updated",
    toastStatusError: "Failed to update sales agent status",
    scopedHelp:
      "Assign this agent to specific activities or structures with a commission rate.",
    activitySection: "Activities",
    houseSection: "Structures",
    addActivity: "Assign activity",
    addHouse: "Assign structure",
    colActivity: "Activity",
    colHouse: "Structure",
    colOwner: "Owner",
    colHost: "Host",
    colSaRate: "Sales agent rate",
    emptyActivities: "No activity assignments yet.",
    emptyHouses: "No structure assignments yet.",
    remove: "Remove",
    removeConfirmActivity: "Remove this activity’s sales agent assignment?",
    removeConfirmHouse: "Remove this structure’s sales agent assignment?",
    modalActivityTitle: "Assign activity",
    modalActivitySubtitle:
      "Choose an activity, then set the commission this agent earns on that activity's bookings.",
    modalHouseTitle: "Assign structure",
    modalHouseSubtitle:
      "Choose a structure, then set the commission this agent earns on that structure's bookings.",
    selectActivityStep: "Select activity",
    selectStructureStep: "Select structure",
    searchActivitiesPlaceholder: "Search by activity or owner name…",
    searchStructuresPlaceholder: "Search by structure or owner name…",
    noActivitiesFound: "No activities found.",
    noStructuresFound: "No structures found.",
    saCommissionPercentLabel: "Sales agent commission (%)",
    invalidCommission: "Enter a valid commission percentage.",
  },
  associations: {
    title: "Your assignments",
    description:
      "Each row is one activity or structure you are assigned to, with your commission rate",
    loading: "Loading assignments...",
    errorLoad: "Could not load assignments",
    colName: "Activity / structure",
    colOwner: "Owner (user id)",
    colRate: "Your rate",
    scopeActivity: "Activity",
    scopeHouse: "Structure",
    statActivities: "Activities",
    statHouses: "Structures",
    statTopRate: "Highest rate",
    empty:
      "No assignments yet. Contact staff to link your account to activities or structures.",
  },
} as const;
